import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupSite } from '../../../../Models/ILookupSite';
import { LookupService } from 'src/app/Services/LookupService';
import { IFormNotificationOfAppeal } from "../../../../Models/Forms/IFormNotificationOfAppeal";
import { FormNotificationOfAppealService } from "../../../../Services/FormNotificationOfAppealService";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'NotificationOfAppeal',
  templateUrl: './NotificationOfAppeal.component.html',
  styleUrls: ['./NotificationOfAppeal.component.css']

})

export class FormNotificationOfAppealComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  panel1: boolean;
  panel2: boolean;
  panel3: boolean;
  panel4: boolean;
  panelNumber: number;
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupSite[];
  _lookupService: LookupService;
  formNotificationOfAppealDB: any = [];
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  firstParagraph: string = 'This report of the Program Planning Committee contains decisions regarding your pupil’s special educations needs. As the parent of this pupil, you have the right to use the following procedures if you disagree with the committee’s decision or recommendations. You also have the right to seek civil action.';
  secondParagraph: string = 'These procedures may also be used if you disagree with the pupil’s assessment. In such cases, you may obtain an independent assessment of the pupil. Resources for both an independent pupil’s assessment and legal services will be provided upon receipt of a written notice of appeal. Results of such an assessment may be part of the Pupil’s record.';
  thirdParagraph: string = 'We welcome the opportunity to discuss any concern you have regarding of this pupil. You may contact the school or area office for discussion. For information, call the Compliance Support Services Coordinator-in-Charge, (562)803-8338. These procedures maybe terminated at any step at which the problem is solved.';
  procedureStepsHeading: string = "PROCEDURE FOR RESOLVING DIFFERENCES REGARDING IDENTIFICATION, ASSESMENT, OR PLACEMENT";
  procedureStep1: string = '1. Inform the administrator (principal) of the Individualized Education Program Team of your concern. If the problem cannot be solved at the school level, we welcome the opportunity to discuss your concern at an informal conference in an effort to come to mutual resolution.';
  procedureStep2: string = '2. The area administrator will complete informal review of your concern within ten (10) days. You will be notified in advance in writing of this conference which will be arranged at a mutually convenient time.';
  procedureStep3: string = '3. If this conference fails to resolve the problem, or if you do not wish to participate in an informal conference, you may initiate a formal appeal by submitting a written appeal to the Office of Administrative Hearings (OAH), Special Education Unit, 1102 Q Street, 4th Floor, Sacramento, CA 95814, with a copy to this office. During the appeal process, the pupil remains in current placement except by mutual consent or if the pupil presents a danger to self or others.';
  procedureStep4: string = '4. Upon receipt of your request, the Office of Administrative Hearings will notify both parties in writing of procedures for resolving the issue(s).';
  procedureStep5: string = '5. These procedures may include a mediation conference.';
  procedureStep6: string = '6. Due Process Hearings are conducted by an administrative officer knowledgeable in laws governing special education.';
  noticeText: string = 'If you have any questions about the above or need further information, please contact the school principal.';

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formNotificationOfAppealService: FormNotificationOfAppealService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormNotificationOfAppealDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadFormNotificationOfAppealDetails(): void {
    this._formNotificationOfAppealService.getFormNotificationOfAppeal(this._myGlobals.selectedFormDetails.formId).subscribe((res: IFormNotificationOfAppeal) => {
      this.formNotificationOfAppealDB = res;
      this.formNotificationOfAppealDB.dateAdded = this.formNotificationOfAppealDB.dateAdded == null ? null : new Date(this.formNotificationOfAppealDB.dateAdded);
    },
      err => console.error(err)
    );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formNotificationOfAppealService.insertUpdateFormNotificationOfAppeal(this.formNotificationOfAppealDB)
      .subscribe((res: IFormNotificationOfAppeal) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.validateForm();
        this.LoadFormNotificationOfAppealDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formNotificationOfAppealService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }
  
  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormNotificationOfAppealDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formNotificationOfAppealDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formNotificationOfAppealDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'isAssessment', parameterValue: 'True' },
      { parameterName: 'IEPID', parameterValue: this.formNotificationOfAppealDB.iepId.toString() },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formNotificationOfAppealDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formNotificationOfAppealDB.rdlFileNameSpanish, this.reportParamArray);
  }

}


